export enum ManagedUserStatusEnum {
  ACTIVE = 1,
  BLOCKED = 0,
}

export const ManagedUserStatusTranslationMap = {
  [ManagedUserStatusEnum.ACTIVE]: 'MANAGED_USERS.ACTIVE',
  [ManagedUserStatusEnum.BLOCKED]: 'MANAGED_USERS.BLOCKED',
};
